import TemplateView from '../../TemplateView'
import {Browser} from '../../constants'

export default class CookiesInstruction extends TemplateView {
    constructor({
        browser,
    }) {
        super()

        this.params = {
            browser,
        }
    }

    templateHtml() {
        return '<div class="instructions">' +
               '    <div class="instruction <%=chrome%>">' +
               '        <div class="title"><%=chromeTitle%></div>' +
               '        <ol class="paragraphs">' +
               '            <li><%=chromeParagraph1%></li>' +
               '            <li><%=chromeParagraph2%></li>' +
               '            <li><%=chromeParagraph3%></li>' +
               '            <li><%=chromeParagraph4%></li>' +
               '            <li><%=chromeParagraph5%></li>' +
               '        </ol>' +
               '    </div>' +
               '    <div class="instruction <%=safari%>">' +
               '        <div class="title"><%=safariTitle%></div>' +
               '        <ol class="paragraphs">' +
               '            <li><%=safariParagraph1%></li>' +
               '            <li><%=safariParagraph2%></li>' +
               '            <li><%=safariParagraph3%></li>' +
               '            <li><%=safariParagraph4%></li>' +
               '        </ol>' +
               '    </div>' +
               '    <div class="instruction <%=edge%>">' +
               '        <div class="title"><%=edgeTitle%></div>' +
               '        <ol class="paragraphs">' +
               '            <li><%=edgeParagraph1%></li>' +
               '            <li><%=edgeParagraph2%></li>' +
               '            <li><%=edgeParagraph3%></li>' +
               '            <li><%=edgeParagraph4%></li>' +
               '            <li><%=edgeParagraph5%></li>' +
               '        </ol>' +
               '    </div>' +
               '    <div class="instruction <%=ie%>">' +
               '        <div class="title"><%=ieTitle%></div>' +
               '        <ol class="paragraphs">' +
               '            <li><%=ieParagraph1%></li>' +
               '            <li><%=ieParagraph2%></li>' +
               '            <li><%=ieParagraph3%></li>' +
               '            <li><%=ieParagraph4%></li>' +
               '            <li><%=ieParagraph5%></li>' +
               '            <li><%=ieParagraph6%></li>' +
               '        </ol>' +
               '    </div>' +
               '    <div class="instruction <%=firefox%>">' +
               '        <div class="title"><%=firefoxTitle%></div>' +
               '        <ol class="paragraphs">' +
               '            <li><%=firefoxParagraph1%></li>' +
               '            <li><%=firefoxParagraph2%></li>' +
               '            <li><%=firefoxParagraph3%></li>' +
               '            <li><%=firefoxParagraph4%></li>' +
               '        </ol>' +
               '    </div>' +
               '    <div class="instruction <%=opera%>">' +
               '        <div class="title"><%=operaTitle%></div>' +
               '        <ol class="paragraphs">' +
               '            <li><%=operaParagraph1%></li>' +
               '            <li><%=operaParagraph2%></li>' +
               '            <li><%=operaParagraph3%></li>' +
               '            <li><%=operaParagraph4%></li>' +
               '        </ol>' +
               '    </div>' +
               '</div>'
    }

    templateModel() {
        return {
            chrome: Browser.CHROME,
            safari: Browser.SAFARI,
            edge: Browser.EDGE,
            ie: Browser.IE,
            firefox: Browser.FIREFOX,
            opera: Browser.OPERA,
        }
    }

    messageKeys() {
        return {
            chromeTitle: 'login.cookies_disabled.instruction.chrome.browser',
            chromeParagraph1: 'login.cookies_disabled.instruction.chrome.paragraph1',
            chromeParagraph2: 'login.cookies_disabled.instruction.chrome.paragraph2',
            chromeParagraph3: 'login.cookies_disabled.instruction.chrome.paragraph3',
            chromeParagraph4: 'login.cookies_disabled.instruction.chrome.paragraph4',
            chromeParagraph5: 'login.cookies_disabled.instruction.chrome.paragraph5',

            safariTitle: 'login.cookies_disabled.instruction.safari.browser',
            safariParagraph1: 'login.cookies_disabled.instruction.safari.paragraph1',
            safariParagraph2: 'login.cookies_disabled.instruction.safari.paragraph2',
            safariParagraph3: 'login.cookies_disabled.instruction.safari.paragraph3',
            safariParagraph4: 'login.cookies_disabled.instruction.safari.paragraph4',

            edgeTitle: 'login.cookies_disabled.instruction.edge.browser',
            edgeParagraph1: 'login.cookies_disabled.instruction.edge.paragraph1',
            edgeParagraph2: 'login.cookies_disabled.instruction.edge.paragraph2',
            edgeParagraph3: 'login.cookies_disabled.instruction.edge.paragraph3',
            edgeParagraph4: 'login.cookies_disabled.instruction.edge.paragraph4',
            edgeParagraph5: 'login.cookies_disabled.instruction.edge.paragraph5',

            ieTitle: 'login.cookies_disabled.instruction.ie.browser',
            ieParagraph1: 'login.cookies_disabled.instruction.ie.paragraph1',
            ieParagraph2: 'login.cookies_disabled.instruction.ie.paragraph2',
            ieParagraph3: 'login.cookies_disabled.instruction.ie.paragraph3',
            ieParagraph4: 'login.cookies_disabled.instruction.ie.paragraph4',
            ieParagraph5: 'login.cookies_disabled.instruction.ie.paragraph5',
            ieParagraph6: 'login.cookies_disabled.instruction.ie.paragraph6',

            firefoxTitle: 'login.cookies_disabled.instruction.firefox.browser',
            firefoxParagraph1: 'login.cookies_disabled.instruction.firefox.paragraph1',
            firefoxParagraph2: 'login.cookies_disabled.instruction.firefox.paragraph2',
            firefoxParagraph3: 'login.cookies_disabled.instruction.firefox.paragraph3',
            firefoxParagraph4: 'login.cookies_disabled.instruction.firefox.paragraph4',

            operaTitle: 'login.cookies_disabled.instruction.opera.browser',
            operaParagraph1: 'login.cookies_disabled.instruction.opera.paragraph1',
            operaParagraph2: 'login.cookies_disabled.instruction.opera.paragraph2',
            operaParagraph3: 'login.cookies_disabled.instruction.opera.paragraph3',
            operaParagraph4: 'login.cookies_disabled.instruction.opera.paragraph4',
        }
    }

    afterRender() {
        this.find(`.${this.params.browser}`).show()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/login/CookiesInstruction.js